export default __webpack_public_path__ + "static/media/search-curriculum.5fdf5618.svg";